var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Create") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.38,10a2.48,2.48,0,1,0,2.48,2.48A2.48,2.48,0,0,0,11.38,10Zm1.5,2.88h-1.1V14H11v-1.1H9.88v-.79H11V11h.79v1.11h1.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.27,12.16h-6v-11h5.8v2.6h2.62V9.5a3.1,3.1,0,0,1,.69-.08,3,3,0,0,1,.43,0V3.32l-.07-.06C10.67,2.2,9.61,1.13,8.55.07c0,0,0,0-.06-.07H1.9L1.79,0a.83.83,0,0,0-.63.7s0,.06,0,.09V12.48a1.16,1.16,0,0,0,0,.18.83.83,0,0,0,.77.62H8.32a3.38,3.38,0,0,1-.08-.72A2.69,2.69,0,0,1,8.27,12.16Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.63,5.12H3.32v.61H9.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33,7.28h6.3V6.67H3.33Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33,8.23v.61h6.3V8.23Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32,2.62h-3v.77h3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.abe9f5c4dc89c6268027937476a00203.svg";
export { ForwardRef as ReactComponent };